<div class="tw-flex">
  <input [(ngModel)]="route">
  <button
    sb-button-primary
    color="blue"
    type="button"
    (click)="routeToPoint()">
    Navigieren
  </button>

</div>

